export const locationReqUrl = 'https://freegeoip.net/json/';
export const weatherApiUrl = 'https://api.darksky.net/forecast';
export const weatherApiId = 'f482f8eeaaf27e35c0bc1b223999502f';




// WEBPACK FOOTER //
// ./src/config.js